import { ButtonPrimary } from '@/components/button'
import { Close } from '@/components/icons'
import { Dialog, Transition } from '@headlessui/react'
import { Dispatch, Fragment, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: () => void
  title: string
  onSubmit: (params?: any) => any
  eligibleBrackets: any[]
  targetBracket: any
  setTargetBracket: Dispatch<SetStateAction<any>>
  disabledSubmitBtn: boolean
}

export const SelectBracketModal = ({
  open,
  onClose,
  title,
  onSubmit,
  eligibleBrackets,
  targetBracket,
  setTargetBracket,
  disabledSubmitBtn,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full flex flex-col gap-y-4 max-w-2xl transform overflow-hidden rounded-2xl bg-white px-6 py-4 text-left align-middle shadow-xl transition-all relative">
                <button
                  className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center ml-2 hover:bg-opacity-20 absolute right-2 top-2"
                  onClick={onClose}
                >
                  <Close className="text-navy-900" />
                </button>

                <Dialog.Title as="h3" className="text-xl text-navy-900 font-semibold">
                  {title}
                </Dialog.Title>

                <h3 className="text-navy-900 font-semibold text-base">{t('event.selectBracketsToSwitch')}</h3>

                <div className="flex flex-col gap-y-3 mx-6 max-h-56 overflow-y-auto">
                  {eligibleBrackets.map((item) => {
                    return (
                      <label
                        key={item.bracketId}
                        className={`flex items-center rounded gap-x-4 px-2 py-4 ${
                          item.isDisable ? 'bg-gray-200' : 'bg-slate-100'
                        }`}
                      >
                        <input
                          type="checkbox"
                          className={`w-5 h-5`}
                          disabled={item.isDisable}
                          checked={targetBracket?.bracketId === item?.bracketId}
                          onChange={() => {
                            if (item?.bracketId !== targetBracket?.bracketId)
                              setTargetBracket({
                                ...item,
                                targetBracketId: item?.bracketId,
                                targetBracketName: item?.name,
                              })
                            if (item?.bracketId === targetBracket?.bracketId) return
                          }}
                        />
                        <span className={`text-sm text-navy-900 ${item.isDisable && 'text-opacity-30'} font-medium`}>
                          {item?.name}
                        </span>
                        <span className={`text-xs text-boldOrange`}>{item?.disableReason}</span>
                      </label>
                    )
                  })}
                </div>

                <div className="flex  justify-center gap-x-6">
                  <button
                    className="py-[6px] px-10 rounded text-sm text-navy-900 font-semibold border shadow-md hover:bg-slate-100"
                    onClick={onClose}
                  >
                    {t('common.back')}
                  </button>
                  <ButtonPrimary
                    title={t('common.next')}
                    className="!py-[6px] !px-10 !rounded"
                    onClick={onSubmit}
                    disabled={disabledSubmitBtn}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
